export default "__VITE_ASSET__129423cf__"